import Vue from 'vue';
import Router from 'vue-router';

/**
 * Layzloading will create many files and slow on compiling, so best not to use lazyloading on devlopment.
 * The syntax is lazyloading, but we convert to proper require() with babel-plugin-syntax-dynamic-import
 * @see https://doc.laravue.dev/guide/advanced/lazy-loading.html
 */

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

/* Router for modules */
import adminRoutes from './modules/admin';
import offersRoutes from './modules/offers';
import investmentsRoutes from './modules/investments';
import blogRoutes from './modules/blog';
import subscriptionRoutes from './modules/subscription';
import transactionsRoutes from './modules/transactions';
import settingRoutes from './modules/setting';
import newsletterRoutes from './modules/newsletter';
import footerRoutes from './modules/footer';
import integrationRoutes from './modules/integration';
import mlsRoutes from './modules/mls';
import crmRoutes from './modules/crm';
import agencyJobsRoutes from './modules/agency-jobs';
import cmsPagesRoutes from './modules/cms-pages';

/**
 * Sub-menu only appear when children.length>=1
 * @see https://doc.laravue.dev/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin', 'editor']   Visible for these roles only
    permissions: ['view menu zip', 'manage user'] Visible for these permissions only
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb (default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
**/

export const constantRoutes = [{
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [{
            path: '/redirect/:path*',
            component: () =>
                import ('@/views/redirect/index'),
        }, ],
    },
    {
        path: '/login',
        component: () =>
            import ('@/views/login/index'),
        hidden: true,
    },
    {
        path: '/sendmail',
        component: () =>
            import ('@/views/login/sendmail'),
        hidden: true,
    },
    {
        path: '/reset',
        component: () =>
            import ('@/views/login/reset'),
        hidden: true,
    },
    {
        path: '/auth-redirect',
        component: () =>
            import ('@/views/login/AuthRedirect'),
        hidden: true,
    },
    {
        path: '/404',
        redirect: { name: 'Page404' },
        component: () =>
            import ('@/views/error-page/404'),
        hidden: true,
    },
    {
        path: '/401',
        component: () =>
            import ('@/views/error-page/401'),
        hidden: true,
    },
    {
        path: '',
        component: Layout,
        redirect: 'dashboard',
        children: [{
            path: 'dashboard',
            component: () =>
                import ('@/views/dashboard/index'),
            name: 'Dashboard',
            meta: { title: 'dashboard', icon: 'el-icon-info', noCache: false },
        }, ],
    },
    {
        path: '/black-list',
        component: Layout,
        redirect: 'black-list',
        children: [{
            path: 'black-list',
            component: () =>
                import ('@/views/black-list/List'),
            name: 'BlackList',
            meta: { title: 'Zakazane słowa', icon: 'el-icon-error', noCache: false },
        }, ],
    },
    {
        path: '/faq',
        component: Layout,
        redirect: 'faq',
        children: [{
            path: 'faq',
            component: () =>
                import ('@/views/faq/index'),
            name: 'FAQ',
            meta: { title: 'FAQ', icon: 'el-icon-question', noCache: true },
        }, ],
    },
    {
        path: '/popup',
        component: Layout,
        redirect: 'popup',
        children: [{
            path: 'popup',
            component: () =>
                import ('@/views/popup/index'),
            name: 'Popup',
            meta: { title: 'Popup', icon: 'el-icon-monitor', noCache: true },
        }, ],
    },
    {
        path: '/trusted-companies',
        component: Layout,
        redirect: 'trusted-companies',
        children: [{
            path: 'trusted-companies',
            component: () =>
                import ('@/views/trusted-companies/List'),
            name: 'TrustedCompanies',
            meta: { title: 'Zaufali nam', icon: 'el-icon-office-building', noCache: true },
        }, ],
    },
];

export const asyncRoutes = [
    adminRoutes,
    offersRoutes,
    investmentsRoutes,
    blogRoutes,
    subscriptionRoutes,
    transactionsRoutes,
    settingRoutes,
    newsletterRoutes,
    footerRoutes,
    integrationRoutes,
    mlsRoutes,
    crmRoutes,
    agencyJobsRoutes,
    cmsPagesRoutes,
    { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.MIX_LARAVUE_PATH,
    routes: constantRoutes,
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;